const ThirdPartyInfoCopy = {
  title: 'How to use',
  text: `1. Tap the button below to reveal your code
2. Apply this unique code at the Deliveroo checkout screen`,
  info: 'Once revealed, your code will be valid until the end of day',
};

export default ThirdPartyInfoCopy;
